import { render, staticRenderFns } from "./ScrollLoad.vue?vue&type=template&id=5f161ab8&"
import script from "./ScrollLoad.vue?vue&type=script&lang=js&"
export * from "./ScrollLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports